import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManagementRoutingModule } from './user-management-routing.module';
import { SharedModule } from '../../../../shared/shared.module';
import { UserManagmentMainComponent } from './user-managment-main/user-managment-main.component';
import { UserManagementListComponent } from './user-management-list/user-management-list.component';
import { UserManagementAddComponent } from './user-management-add/user-management-add.component';
import { UserManagementService } from '../../../../shared/_services/user-management.service';
import { UserManagementDetailsComponent } from './user-management-details/user-management-details.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UserManagementRoutingModule
  ],
  declarations: [UserManagmentMainComponent, UserManagementListComponent, UserManagementAddComponent, UserManagementDetailsComponent ],
  providers: [UserManagementService],
})
export class UserManagementModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/user-management/user-management.module.ts